import { IReporteIngresosParams, IReporteIngresosProdutosRes } from "@/erp/compras/reporte-compra/types";
import { erpApi } from "@/shared/axios";
import { urlBackend } from "@/shared/constants";
import { getUrlParamsFetch } from "@/shared/utils";
import { useQuery } from "@tanstack/react-query";

const { get } = erpApi()
//hook
export const useGetReporteIngresosProductosExcel = (
  params?: IReporteIngresosParams,
  enabled: boolean = false
) => {
  return useQuery({
    ///identificador unico
    queryKey: ['Reporte-Compra', ...Object.values(params || {})],
    //funcion que realmente hace la peitcion
    queryFn: async () => {return getReporteIngresosProductosExcel(params)},
    enabled
  })
}
///funcion
export const getReporteIngresosProductosExcel = async (params?: IReporteIngresosParams) => {
  const queryParams = getUrlParamsFetch({ ...params })
  return get<IReporteIngresosProdutosRes>(`${urlBackend}api/v1/reportes/ingresos-productos-oc/excel/?${queryParams}`, true)
}